// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__szSoG","select":"styles_select__2wRJZ"};